import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsBodyExtraSmall = withStyles(() =>
  createStyles({
    root: {},
  })
)((props: TypographyAllProps) => (
  <Typography variant="body2" component="p" {...props} />
));

export default FsBodyExtraSmall;
